import { currentSeason, type Season } from '../domain/season';

const DEFAULT_SPLASH = '/ui/connection-process/connection-background-image.webp';
/** Loading cover per season; a season without its own uses the default. */
const SPLASH_BY_SEASON: Partial<Record<Season, string>> = {
  autumn: '/ui/connection-process/connection-background-autumn.webp',
};

/** The loading-screen cover for the current season. */
export function splashImage(season: Season = currentSeason()): string {
  return SPLASH_BY_SEASON[season] ?? DEFAULT_SPLASH;
}
